import { configureStore, ThunkAction, Action, Middleware } from '@reduxjs/toolkit';
import labResultsReducer from './lab-results/state';
import authReducer from './auth/state';
import auditTrailReducer from './audit-trail/state';
import userTrackerReducer from './user-tracker/state';
import userSubmittedLabResultsReducer from './user-submitted-lab-results/state';
import { createLogger } from 'redux-logger';

const logger = createLogger() as Middleware;
export const store = configureStore({
  reducer: {
    auth: authReducer,
    labResults: labResultsReducer,
    auditTrail: auditTrailReducer,
    userTracker: userTrackerReducer,
    userSubmittedLabResults: userSubmittedLabResultsReducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(logger),
  devTools: process.env.NODE_ENV !== 'production',
});

export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
